import React from 'react';

/**
 * クレジットカード情報の入力
 *
 * セキュリティ上、payjpライブラリが動的に生成する仕組みになっている。
 * ローカル開発環境では表示できない（これはpayjpの制約というよりは、Frekulの制約）
 *
 * shouldAcuireCardTokenがtrueになるとトークン取得処理が走り、
 * onCardTokenAcquiredまたはonCardTokenErrorが呼ばれる。
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function KaraokeOrderFormView2CardInput({
  visible,
  shouldAcquireCardToken,
  onCardTokenAcquired,
  onCardTokenError,
} : {
  visible: boolean,
  shouldAcquireCardToken: boolean,
  onCardTokenAcquired: (acquiredCardToken: string) => void,
  onCardTokenError: (message: string) => void,
}) {
  React.useEffect(() => {
    if (window.initializeCcCardForm) {
      window.initializeCcCardForm({
        cardNumber: {
          path: '#card-number-form',
          options: {
            style: {
              base: {
                fontSize: '16px',
                whiteSpace: 'pre-wrap',
                color: '#515151',
              },
              empty: {
                color: '#bababa !important',
              },
            },
          },
        },
        cardExpiry: {
          path: '#card-expiry-form',
          options: {
            style: {
              base: {
                fontSize: '16px',
                whiteSpace: 'pre-wrap',
                color: '#515151',
              },
              empty: {
                color: '#bababa !important',
              },
            },
          },
        },
        cardCvc: {
          path: '#card-cvc-form',
          options: {
            style: {
              base: {
                fontSize: '16px',
                whiteSpace: 'pre-wrap',
                color: '#515151',
              },
              empty: {
                color: '#bababa !important',
              },
            },
          },
        },
      });
    }
  }, []);

  React.useEffect(() => {
    if (shouldAcquireCardToken) {
      window.createCcCardToken((cardToken: string, message: string) => {
        if (cardToken) {
          onCardTokenAcquired(cardToken);
        } else if (['Unsuccessful', '正の整数'].filter((word) => (message.indexOf(word) !== -1)).length > 0) {
          onCardTokenError('決済が完了できませんでした。しばらく時間をおいて再度お試しください。');
        } else {
          onCardTokenError(message);
        }
      });
    }
  }, [shouldAcquireCardToken]);

  return (
    <>
      <div className="card-form-wrap" style={{ display: visible ? 'block' : 'none' }}>
        <div id="card-number-form" />
        <div id="card-expiry-form" />
        <div id="card-cvc-form" />
      </div>
    </>
  );
}
